export default [
  {
    // 一键下单(caxa)按客下单
    path: "/caxaOneStepOrderByCustomer/retail",
    name: "一键下单(caxa)按客下单",
    component: () => import("./index.vue"),
  },
  {
    // mtds或者客户订单（客户订单mtds订单创建）
    path: "/caxaOneStepOrderByCustomer/mtdsOrCustomerOrder",
    name: "mtdsOrCustomerOrder",
    component: () => import("./mtdsOrCustomerOrder/index.vue"),
    // props: true,
    // props: (route) => ({
    //   pageMode: route.query.pageMode, // 页面模式
    //   serviceId: route.query.serviceId, // 服务号id
    //   orderId: route.query.orderId, // 订单id
    // }),
    meta: {
      name: "新建订单",
      // componentName: "CustomerOrderCreate",
    },
  },
  {
    // mtds或者客户订单（客户订单编辑）
    path: "/caxaOneStepOrderByCustomer/mtdsOrCustomerOrder/edit/:serviceId",
    name: "mtdsOrCustomerOrderEdit",
    component: () => import("./mtdsOrCustomerOrder/index.vue"),
    meta: {
      name: "按客编辑订单",
      // componentName: "CustomerOrderCreate",
    },
  },
  {
    // mtds或者客户订单（客户订单查看）
    path: "/caxaOneStepOrderByCustomer/mtdsOrCustomerOrder/view/:serviceId",
    name: "mtdsOrCustomerOrderView",
    component: () => import("./mtdsOrCustomerOrder/index.vue"),
    meta: {
      name: "按客查看订单",
      componentName: "CustomerOrderCreate",
    },
  },
  {
    // 服务单选择弹窗，通过地址的方式暴露给外部使用，iframe 引用
    path: "/caxaOneStepOrderByCustomer/serviceOrder",
    name: "serviceOrder",
    component: () => import("./serviceOrder/index.vue"),
  },
  {
    // 配置设置弹窗，通过地址的方式暴露给外部使用，iframe 引用
    path: "/caxaOneStepOrderByCustomer/configSetting",
    name: "configSetting",
    component: () => import("./configSetting/index.vue"),
  },
  {
    // 客户资料包弹窗，通过地址的方式暴露给外部使用，iframe 引用
    path: "/caxaOneStepOrderByCustomer/customerDataPackage",
    name: "customerDataPackageIframe",
    component: () => import("./customerDataPackageIframe/index.vue"),
  },
  {
    // 定制合同确认弹窗，通过地址的方式暴露给外部使用，iframe 引用
    path: "/caxaOneStepOrderByCustomer/contractConfirm",
    name: "contractConfirmIframe",
    component: () => import("./contractConfirmIframe/index.vue"),
  },
  {
    // 懒猫合同确认弹窗，通过地址的方式暴露给外部使用，iframe 引用
    path: "/caxaOneStepOrderByCustomer/lanmaoContract",
    name: "lanmaoContractIframe",
    component: () => import("./lanmaoContractIframe/index.vue"),
  },
  {
    // 装修合同确认弹窗，通过地址的方式暴露给外部使用，iframe 引用
    path: "/caxaOneStepOrderByCustomer/decorationContract",
    name: "decorationContractIframe",
    component: () => import("./decorationContractIframe/index.vue"),
  },
  {
    // 国补合同确认弹窗，通过地址的方式暴露给外部使用，iframe 引用
    path: "/caxaOneStepOrderByCustomer/guobuContract",
    name: "guobuContractIframe",
    component: () => import("./guobuContractIframe/index.vue"),
  },
  {
    // 方案绑定服务号弹窗，通过地址的方式暴露给外部使用（新窗口/iframe 引用）
    // 入参 query: fileId(方案id)、fileName(方案名)、softWareDesignType=kujiale、Oauth2-AccessToken
    // 绑定完成或取消后关闭当前页面
    path: "/caxaOneStepOrderByCustomer/bindCase",
    name: "bindCaseIframe",
    component: () => import("./bindCaseIframe/index.vue"),
  },
];



// WEBPACK FOOTER //
// ./src/page/main/caxaOneStepOrderByCustomer/routes.js